import { render, staticRenderFns } from "./AtmosphereView.vue?vue&type=template&id=45913272&scoped=true"
var script = {}
import style0 from "./AtmosphereView.vue?vue&type=style&index=0&id=45913272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45913272",
  null
  
)

export default component.exports